import { ref, reactive, defineComponent, useCssVars, computed, onUpdated, onMounted, openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, normalizeStyle, unref, normalizeClass, createCommentVNode, createElementBlock, Fragment, renderList, resolveDynamicComponent, mergeProps, createVNode, vShow, provide, watch, withModifiers, defineAsyncComponent, getCurrentInstance, inject, getCurrentScope, onScopeDispose } from "vue";
var xo = Object.defineProperty;
var Mo = (e, t, n) => t in e ? xo(e, t, { enumerable: true, configurable: true, writable: true, value: n }) : e[t] = n;
var _e = (e, t, n) => (Mo(e, typeof t != "symbol" ? t + "" : t, n), n);
const Ge = (e, t, n) => {
  const o = e[t];
  return o ? typeof o == "function" ? o() : Promise.resolve(o) : new Promise((a, r) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(r.bind(null, new Error("Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : ""))));
  });
};
var pe;
(function(e) {
  e.Arabic = "ar", e.Basque = "eu", e.Bulgarian = "bg", e.Catalan = "ca", e.Chinese = "zh", e.ChineseTraditional = "zh-TW", e.Croatian = "hr", e.Czech = "cs", e.Danish = "da", e.Deutsch = "de", e.Dutch = "nl", e.English = "en", e.Estonian = "et", e.Finnish = "fi", e.French = "fr", e.Greek = "el", e.Hebrew = "he", e.Hungarian = "hu", e.Icelandic = "is", e.Indonesian = "id", e.Italian = "it", e.Japanese = "ja", e.Korean = "ko", e.Lithuanian = "lt", e.Norwegian = "no", e.Polish = "pl", e.Portuguese = "pt", e.Romanian = "ro", e.Russian = "ru", e.Slovenian = "sl", e.Spanish = "es", e.Swedish = "sv", e.Thai = "th", e.Turkish = "tr", e.Ukrainian = "uk", e.Vietnamese = "vi";
})(pe || (pe = {}));
var Qt;
(function(e) {
  e.Timing = "timing", e.Oraculo = "oraculo", e.VisitorProfile = "visitorProfile", e.VisitorBehaviour = "visitorBehaviour", e.Search = "search", e.TravelParty = "travelParty", e.DataVariables = "dataVariables", e.Demand = "demand";
})(Qt || (Qt = {}));
var Kt;
(function(e) {
  e.Exclude = "exclude", e.Include = "include";
})(Kt || (Kt = {}));
var en;
(function(e) {
  e.Any = "any", e.Is = "is", e.Are = "are", e.IsBetween = "isBetween", e.AreBetween = "areBetween", e.IsLower = "isLower", e.AreLower = "areLower", e.IsHigher = "isHigher", e.IsGreater = "isGreater", e.AreGreater = "areGreater", e.IsBefore = "isBefore", e.AreBefore = "areBefore", e.IsAfter = "isAfter", e.AreAfter = "areAfter", e.Contain = "contain";
})(en || (en = {}));
var tn;
(function(e) {
  e.Is = "is", e.IsNot = "isNot", e.AnyValue = "anyValue", e.NotAnyValue = "notAnyValue", e.Lower = "lower", e.Greater = "greater", e.Contains = "contains", e.NotContains = "notContains";
})(tn || (tn = {}));
var nn;
(function(e) {
  e.Registered = "registered", e.NonRegistered = "non_registered";
})(nn || (nn = {}));
var on;
(function(e) {
  e.Logged = "logged", e.NonLogged = "nonLogged";
})(on || (on = {}));
var an;
(function(e) {
  e.Any = "any", e.First = "first", e.All = "all", e.Search = "search", e.Booked = "booked", e.Custom = "custom";
})(an || (an = {}));
var rn;
(function(e) {
  e.Colors = "colors", e.Fonts = "fonts", e.Button = "button", e.Background = "background", e.Overlay = "overlay";
})(rn || (rn = {}));
var Z;
(function(e) {
  e.None = "none", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Titlecase = "titlecase";
})(Z || (Z = {}));
var de;
(function(e) {
  e.Google = "google", e.File = "file", e.Regular = "regular";
})(de || (de = {}));
var W;
(function(e) {
  e.Custom = "custom", e.Square = "square", e.Medium = "medium", e.Rounded = "rounded";
})(W || (W = {}));
var fe;
(function(e) {
  e.Percentage = "%", e.Pixels = "px", e.Rem = "rem", e.Em = "em";
})(fe || (fe = {}));
var he;
(function(e) {
  e.Solid = "solid", e.Outline = "outline";
})(he || (he = {}));
var ke;
(function(e) {
  e.Url = "url", e.DefaultText = "default_text", e.CustomText = "custom_text", e.NotLinked = "not_linked", e.CustomUrl = "custom_url";
})(ke || (ke = {}));
var R;
(function(e) {
  e.ApplyDiscount = "apply-discount", e.Dismiss = "dismiss", e.Hide = "hide", e.EmptyClick = "empty-click", e.Fallback = "none", e.GenericLinkClick = "generic-link-click", e.LoadScript = "load-script", e.OpenBookingEngine = "open-be", e.OpenUri = "open-uri", e.PredictiveAudience = "predictive-audience", e.SendForm = "send-form", e.SendSaveSearch = "send-save-search", e.SendSiteContact = "send-site-contact", e.SendSubscribe = "send-subscribe", e.Show = "show", e.LoginSigninHandler = "login-signin-handler", e.LoginValidateHandler = "login-validate-handler";
})(R || (R = {}));
var ye;
(function(e) {
  e.NowViewing = "nowViewing", e.TodayViewed = "todayViewed", e.BookedToday = "bookedToday", e.LastReservation = "lastReservation", e.DiscountToday = "discountToday", e.TodaySpecialOffer = "todaySpecialOffer";
})(ye || (ye = {}));
var ae;
(function(e) {
  e.ApplyPromoCode = "apply_promo_code", e.OpenUrl = "open_url", e.OpenMailClient = "open_mail_client", e.CallPhoneNumber = "call_phone_number", e.CloseTool = "close_tool", e.EmailCapture = "email_capture", e.SavedSearch = "saved_search", e.GoMainStep = "go_main_step", e.SendForm = "form", e.OpenBookingEngine = "send_to_be", e.Submit = "submit";
})(ae || (ae = {}));
var sn;
(function(e) {
  e.Default = "default", e.Coupon = "coupon", e.Rate = "rate", e.Corporative = "corpo", e.Group = "group";
})(sn || (sn = {}));
var U;
(function(e) {
  e.Note = "note", e.Layer = "layer", e.Exit = "exit", e.Inliner = "inliner";
})(U || (U = {}));
var q;
(function(e) {
  e.Success = "success", e.Failure = "failure", e.Main = "main";
})(q || (q = {}));
var ee;
(function(e) {
  e.LoginSignin = "login-signin", e.LoginRegister = "login-register", e.LoginSuccess = "login-success";
})(ee || (ee = {}));
var L;
(function(e) {
  e.Activity = "activity", e.Button = "button", e.Countdown = "countdown", e.EmailCapture = "emailCapture", e.Form = "form", e.Heading = "heading", e.ImageWithBehaviour = "imageWithBehaviour", e.Icon = "icon", e.Paragraph = "paragraph", e.Perks = "perks", e.SavedSearch = "savedSearch", e.Spacer = "spacer", e.Login = "login";
})(L || (L = {}));
var Ce;
(function(e) {
  e.None = "none", e.WebExclusive = "web_exclusive", e.SubjectToAvailibity = "subject_to_availability", e.OnlyForSpecificRates = "only_for_specific_rates", e.OnlyForRegisterdUsers = "only_for_registered_users";
})(Ce || (Ce = {}));
var wt;
(function(e) {
  e.Bullets = "bullets", e.Highlights = "highlights";
})(wt || (wt = {}));
var ln;
(function(e) {
  e.None = "none", e.Solid = "solid", e.Outline = "outline";
})(ln || (ln = {}));
var un;
(function(e) {
  e.Normal = "normal", e.Compact = "compact";
})(un || (un = {}));
var qe;
(function(e) {
  e.Date = "date", e.Time = "time";
})(qe || (qe = {}));
var Tt;
(function(e) {
  e.Visitor = "visitor", e.Hotel = "hotel";
})(Tt || (Tt = {}));
var xt;
(function(e) {
  e.Out = "out", e.Inside = "inside";
})(xt || (xt = {}));
var at;
(function(e) {
  e.Single = "single", e.Multiple = "multiple";
})(at || (at = {}));
var Mt;
(function(e) {
  e.ShortText = "shortText", e.Email = "email", e.Phone = "phone", e.Date = "date", e.LongText = "longText", e.DropDown = "dropdown", e.Selection = "selection";
})(Mt || (Mt = {}));
var Fe;
(function(e) {
  e.Top = "T", e.Bottom = "B", e.Left = "L", e.Right = "R", e.UpperLeft = "UL", e.UpperRight = "UR", e.UpperMidLeft = "UML", e.UpperMidRight = "UMR", e.LowerMidLeft = "LML", e.LowerMidRight = "LMR", e.LowerLeft = "LL", e.LowerRight = "LR";
})(Fe || (Fe = {}));
var Le;
(function(e) {
  e.Mobile = "mobile", e.Desktop = "desktop";
})(Le || (Le = {}));
var cn;
(function(e) {
  e.EveryPage = "on_every_page", e.OncePerVisit = "once_per_visit", e.OncePerVisitor = "once_per_visitor", e.OncePerProperty = "once_per_property", e.OncePerBrand = "once_per_brand";
})(cn || (cn = {}));
var dn;
(function(e) {
  e.Load = "load", e.Scroll = "scroll", e.Idle = "idle";
})(dn || (dn = {}));
var pn;
(function(e) {
  e.Regular = "regular", e.Compact = "compact";
})(pn || (pn = {}));
var je;
(function(e) {
  e.Single = "single", e.Multi = "multi";
})(je || (je = {}));
var ne;
(function(e) {
  e.Circular = "circular", e.CustomImage = "custom-image", e.Fullscreen = "full-screen", e.FullscreenMini = "full-screen-mini", e.LowerNotification = "lower-notification", e.NotificationTab = "notification-tab", e.Sidebar = "sidebar", e.SideGradient = "side-gradient", e.Square = "square", e.SquareImage = "square-image", e.Sticky = "sticky", e.StickyImage = "sticky-image";
})(ne || (ne = {}));
var fn;
(function(e) {
  e.Left = "left", e.Center = "center", e.Right = "right";
})(fn || (fn = {}));
const hn = {
  [ye.NowViewing]: "There are XXXXXX people looking at this hotel right now",
  [ye.TodayViewed]: "XXXXXX people have looked at this hotel today",
  [ye.BookedToday]: "XXXXXX people have already booked today",
  [ye.LastReservation]: "Last reservation was XXXXXX hours ago",
  [ye.DiscountToday]: "XXXXXX% discount only today",
  [ye.TodaySpecialOffer]: "Today's special offer: XXXXXX"
}, jo = {
  [Ce.None]: "none",
  [Ce.SubjectToAvailibity]: "Subject to availability",
  [Ce.WebExclusive]: "Web exclusive",
  [Ce.OnlyForRegisterdUsers]: "Only for registered users",
  [Ce.OnlyForSpecificRates]: "Only for specific rates"
};
var re = /* @__PURE__ */ ((e) => (e.Active = "active", e.Sending = "sending", e.Success = "success", e.Failure = "failure", e))(re || {});
const Ho = [
  R.SendForm,
  R.SendSaveSearch,
  R.SendSubscribe
], Eo = [
  // TODO: add empty click here and update button component
  R.ApplyDiscount,
  R.OpenUri,
  R.OpenBookingEngine,
  R.EmptyClick,
  R.Dismiss
], Oo = [
  R.Hide
];
class Io {
  constructor() {
    _e(this, "dataValidators", {});
    _e(this, "state", reactive({
      actions: [],
      buttonState: re.Active,
      stepActive: q.Main,
      stepPrevious: null,
      isFirstStep: true,
      hideFunction: () => {
      }
    }));
  }
  get buttonState() {
    return this.state.buttonState;
  }
  get isFirstStep() {
    return this.state.isFirstStep;
  }
  get stepActive() {
    return this.state.stepActive;
  }
  get stepPrevious() {
    return this.state.stepPrevious;
  }
  initialize(t, n) {
    this.state.hideFunction = t, this.state.actions = n;
  }
  setStepActive(t, n = null) {
    this.state.stepActive = t, this.state.isFirstStep = t === q.Main, this.state.stepPrevious = n;
  }
  setDataValidator(t, n) {
    console.log("setDataValidator", t, n), this.dataValidators[t] = n;
  }
  // accep type as generic for return
  async callHandler(t, n) {
    if (!this.state.actions)
      return false;
    let o = {};
    const a = this.dataValidators[t];
    if (a && (o = await a(), !o))
      return false;
    let r;
    const s = [
      // Some handlers will never come with a moduleId as they do not belong to any content module (dismiss, show..)
      (l) => l.kind === t,
      // Last hope, look for the None action - the default one
      (l) => l.kind === R.Fallback
    ];
    n && s.unshift((l) => l.moduleId === n);
    for (let l = 0; !r && l < s.length; l += 1)
      r = this.state.actions.find(s[l]);
    if (!r)
      return false;
    let i = false;
    return r.handler && (this.state.buttonState = re.Sending, i = await r.handler(o), this.state.buttonState = re.Active), Ho.includes(t) && (this.state.stepActive = i ? q.Success : q.Failure, this.state.isFirstStep = false), Eo.includes(t) && this.callHandler(R.Hide), Oo.includes(t) && this.state.hideFunction(), i;
  }
  goBackToMainStep() {
    this.state.stepPrevious = this.state.stepActive, this.state.stepActive = q.Main, this.state.isFirstStep = true;
  }
  reset() {
    this.state.buttonState = re.Active, this.state.stepActive = q.Main, this.state.isFirstStep = true;
  }
}
function Vo(e, t = 1) {
  let n = e.replace("#", "");
  if (![3, 6].includes(n.length))
    return null;
  n.length === 3 && (n = n.split("").map((a) => a + a).join(""));
  const o = parseInt(n, 16);
  return `rgba(${o >> 16 & 255},${o >> 8 & 255},${o & 255},${t})`;
}
function Bo(e) {
  const t = e.replace(/[-_\s]+(.)?/g, (n, o) => o ? o.toUpperCase() : "");
  return t.substring(0, 1).toUpperCase() + t.substring(1);
}
function Do(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
}
function Fo(e) {
  switch ((e == null ? void 0 : e.kind) || W.Rounded) {
    case W.Custom:
      const n = e;
      return `${n.value}${n.format}`;
    case W.Square:
      return "0px";
    case W.Medium:
      return "6px";
    case W.Rounded:
    default:
      return "16px";
  }
}
function te(e = 0) {
  return `${e}px`;
}
function zo(e = 0) {
  return `${e}em`;
}
function Ke(e) {
  return `${e * 6 / 100}em`;
}
function qo({
  format: e,
  top: t,
  right: n,
  bottom: o,
  left: a
}) {
  switch (e) {
    case fe.Pixels:
      return `${t}${e} ${n}${e} ${o}${e} ${a}${e}`;
    case fe.Em:
    default:
      return `${Ke(t)} ${Ke(n)} ${Ke(o)} ${Ke(a)}`;
  }
}
function Uo(e) {
  return (e == null ? void 0 : e.constructor) === Object;
}
const Xo = {
  apply_promo_code: R.ApplyDiscount,
  close_tool: R.EmptyClick,
  emailCapture: R.SendSubscribe,
  form: R.SendForm,
  open_url: R.OpenUri,
  call_phone_number: R.OpenUri,
  open_mail_client: R.OpenUri,
  savedSearch: R.SendSaveSearch,
  send_to_be: R.OpenBookingEngine
};
function mn(e) {
  return Xo[e];
}
function Go(e, t = Fe.UpperLeft) {
  let n = e;
  switch (t) {
    case Fe.Top:
      n += "-from-top";
      break;
    case Fe.Bottom:
      n += "-from-bottom";
      break;
    default:
      n += `-from-${t.slice(-1) === "L" ? "left" : "right"}`;
      break;
  }
  return n;
}
var Wo = Object.prototype;
function oo(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Wo;
  return e === n;
}
function Zo(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Yo = Zo(Object.keys, Object), Jo = Object.prototype, Qo = Jo.hasOwnProperty;
function Ko(e) {
  if (!oo(e))
    return Yo(e);
  var t = [];
  for (var n in Object(e))
    Qo.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var ao = typeof global == "object" && global && global.Object === Object && global, ea = typeof self == "object" && self && self.Object === Object && self, ve = ao || ea || Function("return this")(), rt = ve.Symbol, ro = Object.prototype, ta = ro.hasOwnProperty, na = ro.toString, Ve = rt ? rt.toStringTag : void 0;
function oa(e) {
  var t = ta.call(e, Ve), n = e[Ve];
  try {
    e[Ve] = void 0;
    var o = true;
  } catch {
  }
  var a = na.call(e);
  return o && (t ? e[Ve] = n : delete e[Ve]), a;
}
var aa = Object.prototype, ra = aa.toString;
function sa(e) {
  return ra.call(e);
}
var ia = "[object Null]", la = "[object Undefined]", gn = rt ? rt.toStringTag : void 0;
function Ie(e) {
  return e == null ? e === void 0 ? la : ia : gn && gn in Object(e) ? oa(e) : sa(e);
}
function Ue(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var ua = "[object AsyncFunction]", ca = "[object Function]", da = "[object GeneratorFunction]", pa = "[object Proxy]";
function so(e) {
  if (!Ue(e))
    return false;
  var t = Ie(e);
  return t == ca || t == da || t == ua || t == pa;
}
var ht = ve["__core-js_shared__"], vn = function() {
  var e = /[^.]+$/.exec(ht && ht.keys && ht.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function fa(e) {
  return !!vn && vn in e;
}
var ha = Function.prototype, ma = ha.toString;
function Re(e) {
  if (e != null) {
    try {
      return ma.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ga = /[\\^$.*+?()[\]{}|]/g, va = /^\[object .+?Constructor\]$/, ba = Function.prototype, _a = Object.prototype, ya = ba.toString, ka = _a.hasOwnProperty, Sa = RegExp(
  "^" + ya.call(ka).replace(ga, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function wa(e) {
  if (!Ue(e) || fa(e))
    return false;
  var t = so(e) ? Sa : va;
  return t.test(Re(e));
}
function Ta(e, t) {
  return e == null ? void 0 : e[t];
}
function We(e, t) {
  var n = Ta(e, t);
  return wa(n) ? n : void 0;
}
var $t = We(ve, "DataView"), Ct = We(ve, "Map"), At = We(ve, "Promise"), Pt = We(ve, "Set"), Lt = We(ve, "WeakMap"), bn = "[object Map]", xa = "[object Object]", _n = "[object Promise]", yn = "[object Set]", kn = "[object WeakMap]", Sn = "[object DataView]", Ma = Re($t), $a = Re(Ct), Ca = Re(At), Aa = Re(Pt), Pa = Re(Lt), $e = Ie;
($t && $e(new $t(new ArrayBuffer(1))) != Sn || Ct && $e(new Ct()) != bn || At && $e(At.resolve()) != _n || Pt && $e(new Pt()) != yn || Lt && $e(new Lt()) != kn) && ($e = function(e) {
  var t = Ie(e), n = t == xa ? e.constructor : void 0, o = n ? Re(n) : "";
  if (o)
    switch (o) {
      case Ma:
        return Sn;
      case $a:
        return bn;
      case Ca:
        return _n;
      case Aa:
        return yn;
      case Pa:
        return kn;
    }
  return t;
});
function lt(e) {
  return e != null && typeof e == "object";
}
var La = "[object Arguments]";
function wn(e) {
  return lt(e) && Ie(e) == La;
}
var io = Object.prototype, Ra = io.hasOwnProperty, ja = io.propertyIsEnumerable, Ha = wn(/* @__PURE__ */ function() {
  return arguments;
}()) ? wn : function(e) {
  return lt(e) && Ra.call(e, "callee") && !ja.call(e, "callee");
}, Ea = Array.isArray, Oa = 9007199254740991;
function lo(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Oa;
}
function Ia(e) {
  return e != null && lo(e.length) && !so(e);
}
function Va() {
  return false;
}
var uo = typeof exports == "object" && exports && !exports.nodeType && exports, Tn = uo && typeof module == "object" && module && !module.nodeType && module, Ba = Tn && Tn.exports === uo, xn = Ba ? ve.Buffer : void 0, Da = xn ? xn.isBuffer : void 0, Fa = Da || Va, Na = "[object Arguments]", za = "[object Array]", qa = "[object Boolean]", Ua = "[object Date]", Xa = "[object Error]", Ga = "[object Function]", Wa = "[object Map]", Za = "[object Number]", Ya = "[object Object]", Ja = "[object RegExp]", Qa = "[object Set]", Ka = "[object String]", er = "[object WeakMap]", tr = "[object ArrayBuffer]", nr = "[object DataView]", or = "[object Float32Array]", ar = "[object Float64Array]", rr = "[object Int8Array]", sr = "[object Int16Array]", ir = "[object Int32Array]", lr = "[object Uint8Array]", ur = "[object Uint8ClampedArray]", cr = "[object Uint16Array]", dr = "[object Uint32Array]", V = {};
V[or] = V[ar] = V[rr] = V[sr] = V[ir] = V[lr] = V[ur] = V[cr] = V[dr] = true;
V[Na] = V[za] = V[tr] = V[qa] = V[nr] = V[Ua] = V[Xa] = V[Ga] = V[Wa] = V[Za] = V[Ya] = V[Ja] = V[Qa] = V[Ka] = V[er] = false;
function pr(e) {
  return lt(e) && lo(e.length) && !!V[Ie(e)];
}
function fr(e) {
  return function(t) {
    return e(t);
  };
}
var co = typeof exports == "object" && exports && !exports.nodeType && exports, Ne = co && typeof module == "object" && module && !module.nodeType && module, hr = Ne && Ne.exports === co, mt = hr && ao.process, Mn = function() {
  try {
    var e = Ne && Ne.require && Ne.require("util").types;
    return e || mt && mt.binding && mt.binding("util");
  } catch {
  }
}(), $n = Mn && Mn.isTypedArray, mr = $n ? fr($n) : pr, gr = "[object Map]", vr = "[object Set]", br = Object.prototype, _r = br.hasOwnProperty;
function yr(e) {
  if (e == null)
    return true;
  if (Ia(e) && (Ea(e) || typeof e == "string" || typeof e.splice == "function" || Fa(e) || mr(e) || Ha(e)))
    return !e.length;
  var t = $e(e);
  if (t == gr || t == vr)
    return !e.size;
  if (oo(e))
    return !Ko(e).length;
  for (var n in e)
    if (_r.call(e, n))
      return false;
  return true;
}
const kr = {
  heading: "#000000",
  paragraph: "#000000",
  link: "#1C8BF1",
  buttonText: "#FFFFFF",
  buttonBackground: "#000000",
  background: {
    base: "#FFFFFF"
  },
  icon: "#000000",
  perks: "#000000",
  countdown: "#F2F2F2",
  countdownText: "#000000",
  countdownNumber: "#000000"
}, Sr = {
  heading: {
    spec: {
      key: "Playfair+Display",
      name: "Playfair Display",
      cssName: "Playfair Display",
      type: "serif",
      fontType: de.Google,
      source: ""
    },
    style: "bold",
    textTransform: Z.None
  },
  paragraph: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: de.Google,
      source: ""
    },
    style: "regular",
    textTransform: Z.None
  },
  formFieldName: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: de.Google,
      source: ""
    },
    style: "regular",
    textTransform: Z.None
  },
  other: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: de.Google,
      source: ""
    },
    style: "regular",
    textTransform: Z.None
  },
  button: {
    spec: {
      key: "Open+Sans",
      name: "Open Sans",
      cssName: "Open Sans",
      type: "sans-serif",
      fontType: de.Google,
      source: ""
    },
    style: "regular",
    textTransform: Z.None
  }
}, Cn = {
  note: {
    style: he.Solid,
    cornerRadius: {
      kind: W.Medium
    },
    padding: {
      top: 8,
      right: 16,
      bottom: 8,
      left: 16,
      format: fe.Em
    }
  },
  layer: {
    style: he.Solid,
    cornerRadius: {
      kind: W.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: fe.Em
    }
  },
  exit: {
    style: he.Solid,
    cornerRadius: {
      kind: W.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: fe.Em
    }
  },
  inliner: {
    style: he.Solid,
    cornerRadius: {
      kind: W.Medium
    },
    padding: {
      top: 14,
      right: 22,
      bottom: 14,
      left: 22,
      format: fe.Em
    }
  }
}, wr = {
  opacity: 100,
  cornerRadius: {
    kind: W.Medium
  }
}, Tr = {
  opacity: 100,
  cornerRadius: {
    kind: W.Medium
  },
  border: {
    color: "#D9D9D9",
    thickness: 1
  }
}, xr = {
  color: "#000000",
  opacity: 50
};
function Mr(e) {
  const t = ref(e), n = computed(
    () => Cn[t.value] || Cn.layer
  );
  return reactive({
    colors: { ...kr },
    fonts: { ...Sr },
    button: { ...n.value },
    background: t.value === "inliner" ? { ...Tr } : { ...wr },
    overlay: { ...xr }
  });
}
function Te({
  tool: e,
  context: t,
  toolKind: n
}) {
  let o, a, r, s;
  const {
    builderMode: i,
    defaultAssets: l,
    deviceViewport: g,
    firstVisitDate: y,
    actions: c,
    hotelTimezone: f,
    hotelTimezoneOffset: u,
    language: p,
    countdownTimestamp: v
  } = t;
  (yr(e.theme.styles) || !e.theme.styles) && (e.theme.styles = Mr(n));
  const {
    content: {
      modules: h
    },
    settings: {
      devices: S
    },
    theme: {
      styles: x
    }
  } = e;
  return n !== U.Note ? o = e.settings.layout : r = e.tokens, n === U.Inliner && (s = e.settings.embedded), S && (a = S[g].position), {
    language: p,
    device: g,
    position: a,
    modules: h,
    layout: o,
    styles: x,
    actions: c,
    extraData: {
      builderMode: i,
      firstVisitDate: y,
      hotelTimezone: f,
      hotelTimezoneOffset: u,
      defaultAssets: l,
      countdownTimestamp: v,
      tokens: r
    },
    embedded: s
  };
}
function nt(e) {
  const t = /^(&|&amp;|a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i, n = /([A-Za-z0-9\u00C0-\u00FF])/, o = /([ :–—-])/;
  return e.split(o).map((a, r, s) => a.search(t) > -1 && r !== 0 && r !== s.length - 1 && s[r - 3] !== ":" && s[r + 1] !== ":" && (s[r + 1] !== "-" || s[r - 1] === "-" && s[r + 1] === "-") ? a.toLowerCase() : a.substring(1).search(/[A-Z]|\../) > -1 || s[r + 1] === ":" && s[r + 2] !== "" ? a : a.replace(n, (i) => i.toUpperCase())).join("");
}
var Rt = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
Xr(Rt);
function Xr(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function Jr(e, t) {
  switch (e) {
    case "opacity":
      return (parseInt(t, 10) / 100).toString();
    case "thickness":
      return te(parseInt(t, 10));
    case "cssName":
      return `'${t}'`;
    default:
      return t;
  }
}
function Qr(e, t) {
  switch (e) {
    case "cornerRadius":
      return Fo(t);
    case "padding":
      return qo(t);
    default:
      return null;
  }
}
function mo(e, t) {
  return Object.keys(e).reduce((n, o) => {
    var r;
    let a = Jr(o, (r = e[o]) == null ? void 0 : r.toString());
    return Uo(e[o]) && (a = Qr(o, e[o]), !a) ? {
      ...n,
      ...mo(e[o], `${t}-${o}`)
    } : (n[`${t}-${Do(o)}`] = a, n);
  }, {});
}
class Kr {
  constructor() {
    _e(this, "rootDom", null);
    _e(this, "state", reactive({
      colors: {},
      fonts: {},
      button: {},
      background: {},
      overlay: {}
    }));
  }
  get rootElement() {
    return this.rootDom;
  }
  get fonts() {
    return this.state.fonts;
  }
  get backgroundImage() {
    var t, n;
    return (n = (t = this.state.background.image) == null ? void 0 : t.urls) == null ? void 0 : n.edited;
  }
  get backgroundImageAlt() {
    var t;
    return (t = this.state.background.image) == null ? void 0 : t.alt;
  }
  get colors() {
    return this.state.colors;
  }
  get button() {
    return this.state.button;
  }
  initialize(t, n) {
    var a, r, s, i, l, g, y, c, f, u, p, v, h, S, x;
    this.rootDom = n, this.state.colors = t.colors || {}, this.state.fonts = t.fonts || {}, this.state.button = t.button || {}, this.state.background = t.background || {}, this.state.overlay = t.overlay || {};
    const o = mo(this.state, "--thn-tool");
    this.addCssVariables({
      ...o,
      "--thn-tool-colors-icon-back": Vo(((a = t.colors) == null ? void 0 : a.icon) || "#000000", 0.15),
      "--thn-tool-colors-background": (s = (r = t.colors) == null ? void 0 : r.background) != null && s.gradient ? `linear-gradient(to right bottom, ${(l = (i = t.colors) == null ? void 0 : i.background) == null ? void 0 : l.base}, ${(y = (g = t.colors) == null ? void 0 : g.background) == null ? void 0 : y.gradient})` : (f = (c = t.colors) == null ? void 0 : c.background) == null ? void 0 : f.base,
      "--thn-tool-button-background-color": ((u = t.button) == null ? void 0 : u.style) === he.Solid ? (p = t.colors) == null ? void 0 : p.buttonBackground : "transparent",
      "--thn-tool-button-border": ((v = t.button) == null ? void 0 : v.style) === he.Outline ? `solid 2px ${(h = t.colors) == null ? void 0 : h.buttonBackground}` : "transparent",
      "--thn-tool-background-border": (x = (S = t.background) == null ? void 0 : S.border) != null && x.color ? `solid ${o["--thn-tool-background-border-thickness"]} ${t.background.border.color}` : "none"
    });
  }
  addCssVariables(t) {
    Object.keys(t).forEach((n) => {
      var o;
      (o = this.rootDom) == null || o.style.setProperty(n, t[n] || "");
    });
  }
  getCssVariableValue(t) {
    return this.rootDom && getComputedStyle(this.rootDom).getPropertyValue(t);
  }
}
class es {
  constructor() {
    _e(this, "state", reactive({
      language: pe.English,
      device: Le.Desktop,
      literals: {}
    }));
  }
  get device() {
    return this.state.device;
  }
  get language() {
    return this.state.language;
  }
  async initialize(t, n) {
    this.state.language = t ?? pe.English, this.state.device = n ?? Le.Desktop;
    const o = await Ge(/* @__PURE__ */ Object.assign({ "../locales/ar.json": () => import("./note-ar-CfXylqyO.js"), "../locales/bg.json": () => import("./note-bg-CvIJ3-AO.js"), "../locales/ca.json": () => import("./note-ca-ByoNEruG.js"), "../locales/cs.json": () => import("./note-cs-CLhmz00j.js"), "../locales/da.json": () => import("./note-da-eWEAm56t.js"), "../locales/de.json": () => import("./note-de-Bo_BtfXa.js"), "../locales/el.json": () => import("./note-el-DwVu6ZKE.js"), "../locales/en.json": () => import("./note-en-ChfA7XGi.js"), "../locales/es.json": () => import("./note-es-BcktWpVn.js"), "../locales/et.json": () => import("./note-et-C0wMkY2o.js"), "../locales/eu.json": () => import("./note-eu-BvLYxrRt.js"), "../locales/fi.json": () => import("./note-fi-DSAuZNOK.js"), "../locales/fr.json": () => import("./note-fr-DmJuyO8V.js"), "../locales/he.json": () => import("./note-he-CDO_nYXr.js"), "../locales/hr.json": () => import("./note-hr-6OS3NY1U.js"), "../locales/hu.json": () => import("./note-hu-sChuEUad.js"), "../locales/id.json": () => import("./note-id-CmNTBYDi.js"), "../locales/is.json": () => import("./note-is-DTejpmpw.js"), "../locales/it.json": () => import("./note-it-DuHi4BAa.js"), "../locales/ja.json": () => import("./note-ja-BB1shqzz.js"), "../locales/ko.json": () => import("./note-ko-CfoRc4Ly.js"), "../locales/lt.json": () => import("./note-lt-7OY5Sm1F.js"), "../locales/nl.json": () => import("./note-nl-BXN77qDs.js"), "../locales/no.json": () => import("./note-no-WF5RYR3r.js"), "../locales/pl.json": () => import("./note-pl-DWfwQC0k.js"), "../locales/pt.json": () => import("./note-pt-ByVny81e.js"), "../locales/ro.json": () => import("./note-ro-C9iL_aH4.js"), "../locales/ru.json": () => import("./note-ru-C1mbBNYs.js"), "../locales/sk.json": () => import("./note-sk-D8txdoFZ.js"), "../locales/sl.json": () => import("./note-sl-rPP52X3B.js"), "../locales/sv.json": () => import("./note-sv-CQgU08NU.js"), "../locales/th.json": () => import("./note-th-BHzkcM28.js"), "../locales/tr.json": () => import("./note-tr-B2562we6.js"), "../locales/uk.json": () => import("./note-uk-CQsFohgC.js"), "../locales/vi.json": () => import("./note-vi-rpwuKMpR.js"), "../locales/zh-TW.json": () => import("./note-zh-TW-BtUgG7EJ.js"), "../locales/zh.json": () => import("./note-zh-Deohmkia.js") }), `../locales/${this.state.language}.json`, 3);
    this.state.literals = o.default;
  }
  getLiteral(t, n) {
    return n ? nt(this.state.literals[t] || t) : this.state.literals[t] || t;
  }
  getLiteralAbb(t, n) {
    const o = `${t}_abbr`;
    return this.getLiteral(o, n);
  }
  getActivityLiteral(t, n = {}) {
    var a;
    const o = n[t];
    return o ? (a = this.state.literals[hn[t]]) == null ? void 0 : a.replace("XXXXXX", o) : this.state.literals[hn[t]];
  }
  getPerkActiveLiteral(t, n = false) {
    const o = t[this.state.language] || "";
    return n ? nt(o) : o;
  }
  getPerkTooltipLiteral(t) {
    return this.state.literals[jo[t]];
  }
  getActiveModuleText(t, n = false) {
    const o = t[this.device][this.language] || "";
    return n ? nt(o) : o;
  }
  getLocaleImageUrl(t) {
    var n;
    switch (t.languageType) {
      case je.Multi:
        return (n = t.urls[this.language || pe.English]) == null ? void 0 : n.edited;
      case je.Single:
      default:
        return t.urls.edited;
    }
  }
  getLocaleImageAlt(t) {
    switch (t.languageType) {
      case je.Multi:
        return t.alt[this.language || pe.English];
      case je.Single:
      default:
        return t.alt;
    }
  }
}
class ts {
  constructor() {
    _e(this, "initTime", Date.now());
    _e(this, "state", reactive({
      builderMode: false,
      firstVisitDate: null,
      hotelTimezone: "Europe/Madrid",
      defaultAssets: void 0,
      countdownTimestamp: void 0,
      tokens: {}
    }));
  }
  get countdownInitTime() {
    return this.initTime;
  }
  get builderMode() {
    return this.state.builderMode;
  }
  get defaultAssets() {
    return this.state.defaultAssets;
  }
  get countdownTimestamp() {
    return this.state.countdownTimestamp;
  }
  get tokens() {
    return this.state.tokens;
  }
  initialize(t) {
    this.state.builderMode = !!t.builderMode, this.state.firstVisitDate = t.firstVisitDate, this.state.hotelTimezone = t.hotelTimezone, this.state.hotelTimezoneOffset = t.hotelTimezoneOffset, this.state.defaultAssets = t.defaultAssets, this.state.countdownTimestamp = t.countdownTimestamp, this.state.tokens = t.tokens;
  }
  getCountdownTimestamp(t, n) {
    const {
      date: o = Date.now(),
      timezone: a,
      days: r = 0,
      hours: s = 0,
      minutes: i = 0
    } = n;
    if (this.initTime = Date.now(), t === qe.Time) {
      const l = r * 24 * 60 * 60 * 1e3, g = s * 60 * 60 * 1e3, y = i * 60 * 1e3, c = this.state.firstVisitDate ? this.initTime - this.state.firstVisitDate : 0;
      return this.initTime + l + g + y - c;
    }
    if (t === qe.Date && o) {
      const l = new Date(o);
      if (l.setHours(s), l.setMinutes(i), a === Tt.Hotel)
        if (!this.state.hotelTimezoneOffset && this.state.hotelTimezone) {
          const g = (/* @__PURE__ */ new Date()).toLocaleString("en-US", {
            timeZone: this.state.hotelTimezone
          }), c = new Date(g).getTime() - (/* @__PURE__ */ new Date()).getTime();
          l.setTime(l.getTime() - c);
        } else
          this.state.hotelTimezoneOffset && l.setTime(l.getTime() - this.state.hotelTimezoneOffset);
      return l.getTime();
    }
    return null;
  }
}
const go = new es(), vo = {}, bo = {};
function _o() {
  const e = getCurrentInstance();
  return (e == null ? void 0 : e.uid) || 0;
}
function ns() {
  var t;
  const e = getCurrentInstance();
  return (t = e == null ? void 0 : e.proxy) == null ? void 0 : t.$el;
}
function os(e) {
  var o;
  const t = getCurrentInstance(), n = (o = t == null ? void 0 : t.exposed) == null ? void 0 : o.hide;
  e.inited = true, e.hideFunction = n || (() => {
  });
}
function Ze(e) {
  const t = _o(), n = ns(), o = vo[t];
  if (o.inited)
    o.language = e.language, o.rtl = e.language === pe.Arabic || e.language === pe.Hebrew, o.device = e.device, o.extraData.initialize(e.extraData), o.handlers.initialize(o.hideFunction, e.actions), o.literals.initialize(e.language, e.device), o.styles.initialize(e.styles, n);
  else
    throw new Error(`error updating store ${t}: store not inited`);
}
function ct(e) {
  const t = _o(), n = Symbol("useStore injection key"), o = reactive({
    uid: t,
    inited: false,
    language: pe.English,
    device: Le.Desktop,
    hideFunction: () => {
    },
    extraData: new ts(),
    handlers: new Io(),
    literals: go,
    styles: new Kr()
  });
  return vo[t] = o, bo[t] = n, provide(n, o), provide("rootUID", t), onMounted(() => {
    os(o), Ze(e);
  }), o;
}
function X() {
  const e = inject("rootUID");
  if (e !== void 0)
    return inject(bo[e]);
  throw new Error("No UID found to load the store");
}
({
  [L.EmailCapture]: "Your email address has been successfully added to our list.",
  [L.SavedSearch]: "We will send you an email with your search very soon.",
  [L.Form]: "We have received your form submission correctly"
});
({
  [ae.ApplyPromoCode]: "Apply promocode",
  [ae.OpenUrl]: "Continue",
  [ae.CloseTool]: "Close",
  [ae.OpenBookingEngine]: "Book Now",
  [ae.OpenMailClient]: "Contact Now",
  [ae.CallPhoneNumber]: "Call Now"
});
const jt = ref();
[
  L.SavedSearch,
  L.EmailCapture,
  L.Form,
  L.Login
];
function ls(e) {
  return e.find(
    (t) => {
      var n;
      return t.moduleType === L.Button && ((n = t.appearance) == null ? void 0 : n.layout) === "link";
    }
  );
}
ref("Terms and conditions");
ref(false);
var Bn;
const ko = typeof window < "u", ps = (e) => typeof e == "string", ze = () => {
};
ko && ((Bn = window == null ? void 0 : window.navigator) != null && Bn.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function So(e) {
  return getCurrentScope() ? (onScopeDispose(e), true) : false;
}
function qt(e) {
  var t;
  const n = unref(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Ut = ko ? window : void 0;
function De(...e) {
  let t, n, o, a;
  if (ps(e[0]) ? ([n, o, a] = e, t = Ut) : [t, n, o, a] = e, !t)
    return ze;
  let r = ze;
  const s = watch(() => qt(t), (l) => {
    r(), l && (l.addEventListener(n, o, a), r = () => {
      l.removeEventListener(n, o, a), r = ze;
    });
  }, { immediate: true, flush: "post" }), i = () => {
    s(), r();
  };
  return So(i), i;
}
const Dn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Fn = "__vueuse_ssr_handlers__";
Dn[Fn] = Dn[Fn] || {};
var Nn = Object.getOwnPropertySymbols, hs = Object.prototype.hasOwnProperty, ms = Object.prototype.propertyIsEnumerable, gs = (e, t) => {
  var n = {};
  for (var o in e)
    hs.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Nn)
    for (var o of Nn(e))
      t.indexOf(o) < 0 && ms.call(e, o) && (n[o] = e[o]);
  return n;
};
function vs(e, t, n = {}) {
  const o = n, { window: a = Ut } = o, r = gs(o, ["window"]);
  let s;
  const i = a && "ResizeObserver" in a, l = () => {
    s && (s.disconnect(), s = void 0);
  }, g = watch(() => qt(e), (c) => {
    l(), i && a && c && (s = new ResizeObserver(t), s.observe(c, r));
  }, { immediate: true, flush: "post" }), y = () => {
    l(), g();
  };
  return So(y), {
    isSupported: i,
    stop: y
  };
}
function pt(e, t = { width: 0, height: 0 }, n = {}) {
  const o = ref(t.width), a = ref(t.height);
  return vs(e, ([r]) => {
    o.value = r.contentRect.width, a.value = r.contentRect.height;
  }, n), watch(() => qt(e), (r) => {
    o.value = r ? t.width : 0, a.value = r ? t.height : 0;
  }), {
    width: o,
    height: a
  };
}
var Ae;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(Ae || (Ae = {}));
function bs(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: o,
    onSwipeEnd: a,
    onSwipeStart: r,
    passive: s = true,
    window: i = Ut
  } = t, l = reactive({ x: 0, y: 0 }), g = reactive({ x: 0, y: 0 }), y = computed(() => l.x - g.x), c = computed(() => l.y - g.y), { max: f, abs: u } = Math, p = computed(() => f(u(y.value), u(c.value)) >= n), v = ref(false), h = computed(() => p.value ? u(y.value) > u(c.value) ? y.value > 0 ? Ae.LEFT : Ae.RIGHT : c.value > 0 ? Ae.UP : Ae.DOWN : Ae.NONE), S = (P) => [P.touches[0].clientX, P.touches[0].clientY], x = (P, N) => {
    l.x = P, l.y = N;
  }, C = (P, N) => {
    g.x = P, g.y = N;
  };
  let I;
  const z = _s(i == null ? void 0 : i.document);
  s ? I = z ? { passive: true } : { capture: false } : I = z ? { passive: false, capture: true } : { capture: true };
  const m = (P) => {
    v.value && (a == null || a(P, h.value)), v.value = false;
  }, A = [
    De(e, "touchstart", (P) => {
      I.capture && !I.passive && P.preventDefault();
      const [N, w] = S(P);
      x(N, w), C(N, w), r == null || r(P);
    }, I),
    De(e, "touchmove", (P) => {
      const [N, w] = S(P);
      C(N, w), !v.value && p.value && (v.value = true), v.value && (o == null || o(P));
    }, I),
    De(e, "touchend", m, I),
    De(e, "touchcancel", m, I)
  ];
  return {
    isPassiveEventSupported: z,
    isSwiping: v,
    direction: h,
    coordsStart: l,
    coordsEnd: g,
    lengthX: y,
    lengthY: c,
    stop: () => A.forEach((P) => P())
  };
}
function _s(e) {
  if (!e)
    return false;
  let t = false;
  const n = {
    get passive() {
      return t = true, false;
    }
  };
  return e.addEventListener("x", ze, n), e.removeEventListener("x", ze), t;
}
var _t = function() {
  return ve.Date.now();
}, ys = /\s/;
function ks(e) {
  for (var t = e.length; t-- && ys.test(e.charAt(t)); )
    ;
  return t;
}
var Ss = /^\s+/;
function ws(e) {
  return e && e.slice(0, ks(e) + 1).replace(Ss, "");
}
var Ts = "[object Symbol]";
function xs(e) {
  return typeof e == "symbol" || lt(e) && Ie(e) == Ts;
}
var zn = NaN, Ms = /^[-+]0x[0-9a-f]+$/i, $s = /^0b[01]+$/i, Cs = /^0o[0-7]+$/i, As = parseInt;
function qn(e) {
  if (typeof e == "number")
    return e;
  if (xs(e))
    return zn;
  if (Ue(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ue(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = ws(e);
  var n = $s.test(e);
  return n || Cs.test(e) ? As(e.slice(2), n ? 2 : 8) : Ms.test(e) ? zn : +e;
}
var Ps = "Expected a function", Ls = Math.max, Rs = Math.min;
function Ye(e, t, n) {
  var o, a, r, s, i, l, g = 0, y = false, c = false, f = true;
  if (typeof e != "function")
    throw new TypeError(Ps);
  t = qn(t) || 0, Ue(n) && (y = !!n.leading, c = "maxWait" in n, r = c ? Ls(qn(n.maxWait) || 0, t) : r, f = "trailing" in n ? !!n.trailing : f);
  function u(m) {
    var A = o, H = a;
    return o = a = void 0, g = m, s = e.apply(H, A), s;
  }
  function p(m) {
    return g = m, i = setTimeout(S, t), y ? u(m) : s;
  }
  function v(m) {
    var A = m - l, H = m - g, P = t - A;
    return c ? Rs(P, r - H) : P;
  }
  function h(m) {
    var A = m - l, H = m - g;
    return l === void 0 || A >= t || A < 0 || c && H >= r;
  }
  function S() {
    var m = _t();
    if (h(m))
      return x(m);
    i = setTimeout(S, v(m));
  }
  function x(m) {
    return i = void 0, f && o ? u(m) : (o = a = void 0, s);
  }
  function C() {
    i !== void 0 && clearTimeout(i), g = 0, o = l = a = i = void 0;
  }
  function I() {
    return i === void 0 ? s : x(_t());
  }
  function z() {
    var m = _t(), A = h(m);
    if (o = arguments, a = this, l = m, A) {
      if (i === void 0)
        return p(l);
      if (c)
        return clearTimeout(i), i = setTimeout(S, t), u(l);
    }
    return i === void 0 && (i = setTimeout(S, t)), s;
  }
  return z.cancel = C, z.flush = I, z;
}
function wo(e, t) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    createElementVNode("path", { d: "M10.707 10.5l5.646-5.646a.5.5 0 00-.707-.707L10 9.793 4.354 4.147a.5.5 0 00-.707.707L9.293 10.5l-5.646 5.646a.5.5 0 00.708.707l5.646-5.646 5.646 5.646a.498.498 0 00.708 0 .5.5 0 000-.707L10.709 10.5z" })
  ]);
}
const Hs = /* @__PURE__ */ defineComponent({
  __name: "XClose",
  props: {
    triggerDismiss: { type: Boolean, default: true }
  },
  setup(e) {
    const t = X(), n = e, o = Ye(() => {
      var a;
      n.triggerDismiss === true && ((a = t.handlers) == null || a.callHandler(R.Dismiss));
    }, 200, { leading: true, trailing: false });
    return (a, r) => (openBlock(), createElementBlock("div", {
      class: "thn--tool-xclose",
      onMousedown: r[0] || (r[0] = withModifiers(
        //@ts-ignore
        (...s) => unref(o) && unref(o)(...s),
        ["left"]
      )),
      onClick: r[1] || (r[1] = //@ts-ignore
      (...s) => unref(o) && unref(o)(...s))
    }, [
      createVNode(unref(wo), { class: "thn--tool-xclose__svg" })
    ], 32));
  }
}), Es = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function xe(e = Es, t = Le.Desktop, n = U.Layer) {
  const {
    fontSize: o,
    lineHeight: a,
    letterSpacing: r
  } = e, s = t === Le.Mobile ? 0.8 : 1, i = Math.round(o * s), l = Math.round(a), g = (r ?? 0) / 100;
  return {
    fontSize: te(i < 14 && n === U.Note ? 14 : i),
    lineHeight: te(l < 14 && n === U.Note ? 14 : l),
    letterSpacing: r ? zo(g) : "normal"
  };
}
const Os = ["button-state", "moduleType", "data-module-id", "data-full-width"], Is = {
  key: 0,
  class: "thn--tool-button__back"
}, Vs = ["innerHTML"], Bs = ["innerHTML"], Ds = {
  key: 3,
  class: "thn--tool-button__sending loader"
}, Fs = /* @__PURE__ */ createElementVNode("div", { class: "la-ball-pulse" }, [
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div"),
  /* @__PURE__ */ createElementVNode("div")
], -1), Ns = [
  Fs
], To = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    toolKind: {}
  },
  setup(e) {
    useCssVars((l) => ({
      "1d3c56d4": o.value,
      eab63622: a.value
    }));
    const t = X(), n = e, o = computed(() => t != null && t.rtl ? "flex-end" : "none"), a = computed(() => t != null && t.rtl ? "flex-start" : "none"), r = computed(() => {
      var l;
      return t == null ? void 0 : t.literals.getActiveModuleText(
        n.moduleProps,
        ((l = t == null ? void 0 : t.styles.fonts[n.moduleProps.moduleType]) == null ? void 0 : l.textTransform) === Z.Titlecase
      );
    }), s = computed(
      () => xe(n.moduleProps.appearance, t == null ? void 0 : t.device, n.toolKind)
    ), i = Ye(() => {
      if ((t == null ? void 0 : t.handlers.buttonState) !== re.Sending)
        if (n.hasExtraSteps && !n.moduleProps.id.includes("extra"))
          jt.value && (jt.value.scrollTop = 0), t == null || t.handlers.callHandler(mn(n.hasExtraSteps));
        else if (n.moduleProps.behaviour.type === ae.GoMainStep)
          t == null || t.handlers.goBackToMainStep();
        else {
          const l = mn(n.moduleProps.behaviour.type);
          t == null || t.handlers.callHandler(l, n.moduleProps.id);
        }
    }, 200, { leading: true, trailing: false });
    return (l, g) => {
      var y, c, f;
      return openBlock(), createElementBlock("div", {
        role: "button",
        tabindex: "0",
        class: normalizeClass([
          "thn--tool-button",
          { "inline-layout": l.isLinkLayout }
        ]),
        "button-state": (y = unref(t)) == null ? void 0 : y.handlers.buttonState,
        style: normalizeStyle(s.value),
        moduleType: l.moduleProps.moduleType,
        "data-module-id": l.moduleProps.id,
        "data-full-width": (c = l.moduleProps.appearance) == null ? void 0 : c.fullWidth,
        onMousedown: g[0] || (g[0] = withModifiers(
          //@ts-ignore
          (...u) => unref(i) && unref(i)(...u),
          ["left"]
        )),
        onClick: g[1] || (g[1] = //@ts-ignore
        (...u) => unref(i) && unref(i)(...u))
      }, [
        l.isLinkLayout ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", Is)),
        l.isLinkLayout ? (openBlock(), createElementBlock("span", {
          key: 2,
          innerHTML: r.value
        }, null, 8, Bs)) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: "thn--tool-button__label",
          innerHTML: r.value
        }, null, 8, Vs)),
        ((f = unref(t)) == null ? void 0 : f.handlers.buttonState) === unref(re).Sending && !l.isLinkLayout ? (openBlock(), createElementBlock("div", Ds, Ns)) : createCommentVNode("", true)
      ], 46, Os);
    };
  }
}), zs = ["innerHTML", "moduleType", "data-module-id"], Ot = /* @__PURE__ */ defineComponent({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {}
  },
  setup(e) {
    const t = {
      [L.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [L.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [L.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    }, n = X(), o = e, a = computed(() => {
      var i;
      return n == null ? void 0 : n.literals.getActiveModuleText(
        o.moduleProps,
        ((i = n == null ? void 0 : n.styles.fonts[o.moduleProps.moduleType]) == null ? void 0 : i.textTransform) === Z.Titlecase
      );
    }), r = computed(
      () => o.moduleProps.appearance || t[o.moduleProps.moduleType]
    ), s = computed(
      () => xe(r.value, n == null ? void 0 : n.device, o.toolKind)
    );
    return (i, l) => (openBlock(), createElementBlock("div", {
      class: "thn--tool-text",
      style: normalizeStyle(s.value),
      innerHTML: a.value,
      moduleType: i.moduleProps.moduleType,
      "data-module-id": i.moduleProps.id
    }, null, 12, zs));
  }
}), qs = ["innerHTML", "data-module-id"], Us = /* @__PURE__ */ defineComponent({
  __name: "Activity",
  props: {
    moduleProps: {}
  },
  setup(e) {
    const t = X(), n = e, o = computed(
      () => t == null ? void 0 : t.literals.getActivityLiteral(
        n.moduleProps.textKey,
        t == null ? void 0 : t.extraData.tokens
      )
    ), a = computed(() => xe(n.moduleProps.appearance, t == null ? void 0 : t.device));
    return (r, s) => (openBlock(), createElementBlock("div", {
      class: "thn--tool-activity",
      innerHTML: o.value,
      "data-module-id": r.moduleProps.id,
      style: normalizeStyle(a.value)
    }, null, 12, qs));
  }
}), Xs = ["data-module-id"], Gs = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    moduleProps: {}
  },
  setup(e) {
    const t = e, n = computed(() => {
      const o = `${Bo(t.moduleProps.value)}Icon`;
      return defineAsyncComponent(() => Ge(/* @__PURE__ */ Object.assign({}), `../../../../node_modules/@thehotelsnetwork/icons/vue/personalization/${o}.js`, 10));
    });
    return (o, a) => (openBlock(), createElementBlock("div", {
      class: "thn--tool-icon",
      "data-module-id": t.moduleProps.id,
      "data-module-special": true
    }, [
      createVNode(unref(n), { class: "thn--tool-icon__svg" })
    ], 8, Xs));
  }
}), Ws = ["data-position", "data-device", "data-builder-mode", "data-text-direction"], Zs = /* @__PURE__ */ createElementVNode("div", { class: "thn--tool-note__back" }, null, -1), Ys = { class: "thn--tool-note__content" }, Js = { class: "thn--tool-note__modules__wrapper" }, Fl = /* @__PURE__ */ defineComponent({
  __name: "Note",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hide",
    "hidden"
  ],
  setup(e, { expose: t, emit: n }) {
    useCssVars((m) => ({
      41968936: S.value,
      "38bcd99e": x.value
    }));
    const o = {
      [L.Paragraph]: Ot,
      [L.Activity]: Us,
      [L.Button]: To
    }, a = e, r = n, s = ct(Te({
      ...a,
      toolKind: U.Note
    })), i = ref(), l = ref(false), { height: g } = pt(i), y = computed(() => {
      const {
        content: {
          modules: m
        }
      } = a.tool;
      return {
        hasLinkLayoutButton: !!ls(m)
      };
    }), c = computed(() => a.tool.content.modules.find((m) => m.moduleType === L.Icon)), f = computed(() => a.tool.content.modules.filter(
      (m) => m.moduleType !== L.Icon
    )), { isSwiping: u, lengthX: p } = bs(i, {
      onSwipeEnd: () => {
        Math.abs(p.value) > 150 && s.handlers.callHandler(R.Dismiss);
      }
    }), v = computed(() => {
      const m = {};
      if (u.value && i.value) {
        const A = -i.value.getBoundingClientRect().width / 2 - p.value;
        m.transform = `translateX(${A}px)`, m.opacity = (100 - Math.abs(p.value / 3)) / 100;
      }
      return {
        ...m
      };
    }), h = computed(() => {
      const { position: m } = a.tool.settings.devices[a.context.deviceViewport];
      return Go("fade", m);
    }), S = computed(() => s != null && s.rtl ? "none" : "12px"), x = computed(() => s != null && s.rtl ? "12px" : "none");
    function C() {
      l.value = false;
    }
    function I() {
      r("hide"), l.value = true;
    }
    function z() {
      r("hidden");
    }
    return onUpdated(() => {
      Ze(Te({
        ...a,
        toolKind: U.Note
      }));
    }), onMounted(() => {
      s.handlers.callHandler(R.Show), a.tool.settings.timing.pagetime && setTimeout(() => {
        s.handlers.callHandler(R.Hide), I();
      }, Number(a.tool.settings.timing.pagetime) * 1e3);
    }), t({
      show: C,
      hide: I
    }), (m, A) => (openBlock(), createBlock(Transition, {
      name: h.value,
      appear: "",
      onAfterLeave: z
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          class: "thn--tool thn--tool-note",
          ref_key: "rootDom",
          ref: i,
          style: normalizeStyle(v.value),
          "data-position": m.tool.settings.devices[m.context.deviceViewport].position,
          "data-device": m.context.deviceViewport,
          "data-builder-mode": m.context.builderMode,
          "data-text-direction": unref(s).rtl ? "rtl" : "ltr"
        }, [
          Zs,
          createElementVNode("div", Ys, [
            c.value ? (openBlock(), createBlock(Gs, {
              key: 0,
              class: normalizeClass(["thn--tool-note__icon", [unref(g) > 72 ? "icon-top" : "icon-center"]]),
              "data-module-id": c.value.id,
              "data-module-special": true,
              "module-props": c.value
            }, null, 8, ["class", "data-module-id", "module-props"])) : createCommentVNode("", true),
            createElementVNode("div", {
              class: normalizeClass([
                "thn--tool-note__modules",
                { "inline-layout": y.value.hasLinkLayoutButton }
              ]),
              "data-add-module": true
            }, [
              createElementVNode("div", Js, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(f.value, (H, P) => (openBlock(), createBlock(resolveDynamicComponent(o[H.moduleType]), mergeProps({
                  class: "thn--tool-note-component",
                  key: P,
                  "is-link-layout": y.value.hasLinkLayoutButton,
                  "tool-kind": unref(U).Note,
                  ref_for: true
                }, {
                  moduleProps: H
                }), null, 16, ["is-link-layout", "tool-kind"]))), 128))
              ])
            ], 2)
          ]),
          createVNode(Hs)
        ], 12, Ws), [
          [vShow, !l.value]
        ])
      ]),
      _: 1
    }, 8, ["name"]));
  }
});
({
  colors: {
    heading: "#CCCCCC",
    paragraph: "#CCCCCC",
    icon: "#000000",
    buttonText: "#ffffff",
    buttonBackground: "#000000",
    background: {
      base: "#ffffff"
    }
  },
  fonts: {
    paragraph: {
      spec: {
        key: "Open+Sans",
        name: "Open Sans",
        cssName: "Open Sans",
        type: "sans-serif",
        fontType: de.Google,
        source: ""
      },
      style: "bold",
      textTransform: Z.None
    },
    button: {
      spec: {
        key: "Open+Sans",
        name: "Open Sans",
        cssName: "Open Sans",
        type: "sans-serif",
        fontType: de.Google,
        source: ""
      },
      style: "bold",
      textTransform: Z.None
    }
  },
  button: {
    style: he.Solid,
    cornerRadius: {
      kind: W.Rounded
    },
    padding: {
      format: fe.Pixels,
      right: 8,
      left: 8,
      top: 24,
      bottom: 24
    }
  },
  background: {
    opacity: 100,
    cornerRadius: {
      kind: W.Rounded
    },
    image: {
      opacity: 10,
      alt: "alt text for background image",
      urls: {
        edited: "https://s3-eu-west-1.amazonaws.com/popups-photos/welcome/back_photo/1440_820/75b2b42a6a40e1a8186b2823c50c7c1a.jpg"
      }
    }
  },
  overlay: {
    opacity: 10,
    color: "#000000"
  }
});
ref(false);
ref();
ref("");
ref("");
export {
  Fl as default
};
//# sourceMappingURL=note.es.js.map
